import { useQuery } from '@tanstack/react-query';

import { PayStationOperation } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/paystations/pay-station-operation/:operationId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    operationId: string;
}
const queryFn = ({ operationId, parkingId }: DTO): Promise<PayStationOperation> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, operationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPayStationOperation, RESOURCE as GET_PAY_STATION_OPERATION_RESOURCE };
